<script>
import { optionsComputed, navComputed, authComputed } from '@state/helpers'
import List from '@views/safehaven/health-record/list.vue'
import layout from '@src/mixins/layout.vue'
import { healthRecordService } from '@services/safehaven/HealthRecordService'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { constants } from '@src/constants/safehaven'
import CollapsibleList from '@/src/components/tables/safehaven-collapsible-list.vue'
import ReceivedRecord from '@/src/components/safehaven/health-record/received-records.vue'
import SharedHealththRecords from '@/src/router/views/safehaven/health-record/shared-health-records.vue'
import moment from 'moment'
export default {
  page: {
    title: 'Health Records',
    meta: [{ name: 'description', content: 'The Health Records page.' }],
  },
  components: { List, CollapsibleList, ReceivedRecord, SharedHealththRecords },
  mixins: [layout, NavigateMixin],

  data() {
    return {
      syptomResponse: [],
      receipentId: '',
      expanded: true,
      hRecords: null,
      loading: false,
      menuItems: constants.healthRecord,
      tab: 0,
      items: '',
      expireDate: '',
    }
  },
  computed: {
    ...authComputed,
    ...navComputed,
    ...optionsComputed,
    computedMenuItems() {
      return this.menuItems
    },
  },

  mounted() {
    this.getAllData(true)

    if (this.$route.params.showReceivedRecords) {
      this.tab = 2
    }
  },
  methods: {
    getFormatedDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    getAllDataNew() {
      setTimeout(() => this.getAllData(false), 2000)
    },
    async getAllData(firstCall) {
      try {
        this.loading = true
        this.hRecords = null
        const healthRecords = (await healthRecordService.getHealthRecord()).data
        if (healthRecords) {
          this.loading = false
          this.hRecords = null
          this.hRecords = healthRecords.results
          this.syptomResponse =
            healthRecords.symptom_checker !== 'No Data Available'
              ? healthRecords.symptom_checker
              : []
          healthRecordService.setHealthRecordData(healthRecords)
          this.items = healthRecords.received_hr_details
          if (firstCall && this.items) {
            const idx = this.items.findIndex(
              (x) =>
                x.sender_name ===
                this.$store.state.calender.sharedRecordTabs?.sender_name
            )

            if (idx !== -1) {
              setTimeout(
                function () {
                  document.getElementById(this.items[idx].record_id).click()
                }.bind(this),
                1000
              )
            }
          }
          var ele = document.getElementById('fetchData')
          if (ele) ele.click()
        }
      } catch (error) {
        this.loading = false
        console.warn(error)
      }
    },
    async updateGetAllData(firstCall) {
      try {
        this.hRecords = null
        const healthRecords = (await healthRecordService.getHealthRecord()).data
        if (healthRecords) {
          this.hRecords = healthRecords.results
          this.syptomResponse =
            healthRecords.symptom_checker !== 'No Data Available'
              ? healthRecords.symptom_checker
              : []
          healthRecordService.setHealthRecordData(healthRecords)
          this.items = healthRecords.received_hr_details
          if (firstCall) {
            const idx = this.items.findIndex(
              (x) =>
                x.sender_name ===
                this.$store.state.calender.sharedRecordTabs?.sender_name
            )
            if (idx !== -1) {
              setTimeout(
                function () {
                  document.getElementById(this.items[idx].record_id).click()
                }.bind(this),
                1000
              )
            }
          }
          document.getElementById('fetchData').click()
        }
      } catch (error) {
        this.loading = false
        console.warn(error)
      }
    },
  },
}
</script>

<template>
  <v-container class="pa-0 mt-5" fluid>
    <v-row>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '10'"
        lg="10"
        xl="10"
        class="ma-auto pr-10 pl-10"
        fill-height
      >
        <h3 class="mt-3" :class="$style.peerHeading">Health Records</h3>
      </v-col>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '10'"
        lg="10"
        xl="10"
        class="ma-auto pr-10 pl-10"
        fill-height
      >
        <div :class="$vuetify.breakpoint.mobile ? '' : $style.pageHeader">
          <p :class="$vuetify.breakpoint.mobile ? 'mr-0' : 'mr-16'">
            Get a complete picture of your health history and your next best
            health action by adding all your medical records, lab results,
            procedures and medications into one secure place.</p
          >
          <img
            v-if="!$vuetify.breakpoint.mobile"
            :class="$style.badgeClss"
            :src="require('@assets/images/safehaven/Secure-Badge.svg')"
          />
        </div>
      </v-col>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
    </v-row>
    <v-row class="">
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '10'"
        lg="10"
        xl="10"
        class="ma-auto pr-10 pl-10 pt-0"
        fill-height
      >
        <v-tabs
          v-model="tab"
          next-icon="mdi-arrow-right-bold-circle"
          prev-icon="mdi-arrow-left-bold-circle"
          show-arrows
          center-active
          background-color="transparent"
          :class="[
            $style.tabClss,
            $vuetify.breakpoint.smAndUp ? 'mt-1' : 'mt-0',
          ]"
          color="rgba(0, 0, 0, 0.87)"
        >
          <v-tab key="1" @click="getAllData(false)"> My records </v-tab>
          <v-tab id="ShareDocHealthRecordTabID" key="2"> Shared Records </v-tab>
          <v-tab key="3"> Received Records</v-tab>

          <v-tabs-items v-model="tab">
            <v-card
              width="100%"
              color="transparent"
              outlined
              rounded="lg"
              loading
            >
              <template slot="progress">
                <v-progress-linear
                  v-if="loading"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <div v-else :class="$style.loaderPlaceholder"></div>
              </template>
            </v-card>
            <v-tab-item>
              <v-row>
                <v-col cols="12" md="12">
                  <List
                    id="healthRecordList"
                    :h-record="hRecords"
                    :sympdfrecords="syptomResponse"
                  ></List>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-for="item in items" :key="item" class="pb-5">
              <v-row
                :class="
                  $vuetify.breakpoint.mdAndDown ? $style.changePosition : ''
                "
              >
                <v-col
                  :class="$vuetify.breakpoint.mdAndDown ? $style.col : ''"
                  cols="12"
                  :md="12"
                >
                  <v-row v-if="tab === 0" class="pt-2">
                    <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                      <p :class="$style.topListNew">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :class="$style.btnClss"
                              v-bind="attrs"
                              @click="
                                $store.dispatch('calender/setExpandAll', 'true')
                              "
                              v-on="on"
                            >
                              <img
                                :src="
                                  require('@assets/images/Health-Record-Icons/icon-expand.svg')
                                "
                                class="imageproduit"
                              />
                            </v-btn>
                          </template>
                          <span>Expand All</span>
                        </v-tooltip>
                        <!--Comma Added HERE-->
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :class="$style.btnClss"
                              v-bind="attrs"
                              @click="
                                $store.dispatch(
                                  'calender/setExpandAll',
                                  // eslint-disable-next-line vue/comma-dangle
                                  'false'
                                )
                              "
                              v-on="on"
                            >
                              <img
                                :src="
                                  require('@assets/images/Health-Record-Icons/icon-collapse.svg')
                                "
                                class="imageproduit"
                              />
                            </v-btn>
                          </template>
                          <span>Collapse All</span>
                        </v-tooltip>
                        <!--Comma Added END-->
                      </p>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0"
                      ><p :class="$style.expireClss" class="mb-0"
                        ><v-icon>mdi-alert-outline</v-icon> Your access to these
                        records will
                        <span class="font-weight-bold"
                          >expire on
                          {{
                            getFormatedDate(item.hr_expiration_date_time)
                          }}</span
                        ></p
                      ></v-col
                    >
                  </v-row>

                  <v-row
                    v-for="model in computedMenuItems"
                    v-else-if="tab === 0"
                    :key="model.plain_resource"
                  >
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      class="pt-0 pb-0"
                      fill-height
                    >
                      <v-fade-transition mode="out-in">
                        <CollapsibleList
                          :icon="model.icon"
                          :color="model.color"
                          :opaque="model.opaque"
                          :pdfrecords="syptomResponse"
                          :headers="model.headers"
                          :sortables="model.sortables"
                          :title="$t(model.title)"
                          :shared="true"
                          :subtitle="
                            model.list_title
                              ? $t(model.list_title)
                              : $t(model.title)
                          "
                          :image="model.imageURL"
                          :resource="model.resource"
                          :recipientid="receipentId"
                        ></CollapsibleList>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>
            <SharedHealththRecords
              v-if="tab === 1"
              :receivers="items"
            ></SharedHealththRecords>

            <ReceivedRecord
              v-if="tab === 2"
              :receivers="items"
            ></ReceivedRecord>
          </v-tabs-items>
        </v-tabs>
      </v-col>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
    </v-row>
    <button id="getAllData" hidden @click="getAllDataNew"></button>
    <button id="updateGetAllData" hidden @click="updateGetAllData"></button>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.active {
  transform: rotate(-180deg);
}
.peerHeading {
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
.btnClss {
  padding: 0 !important;
  margin: 0 6px;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: capitalize;
  background: none !important;
  border: none;
  box-shadow: none !important;
}
.expireClss {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #454648;
  text-align: right;
  letter-spacing: 0.1px;
}
.btnClss:hover {
  background: none !important;
}

.btnClss:first-child {
  padding-right: 5px;
}
.listItem {
  border-radius: 8px !important;
}

.column {
  max-width: 150px;
  padding-right: 30px;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
}
.tabShareList {
  background: #f00;
}
.first {
  max-width: 100%;
}

.actionColumn {
  max-width: 40px;
}
.topListNew {
  padding: 0;
  margin: 0 !important;
  color: #c4c4c4;
  text-align: right;
  text-align: left;
}
.headerRow {
  width: 100% !important;
  min-height: 40px;
}

.listItemRow {
  width: 100% !important;
}

.title {
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.loaderPlaceholder {
  height: 4px;
}

.iconRow {
  height: 100%;
}

.iconContainer {
  border-radius: 3px;
}

.attachmentBtn {
  border: 1px solid $color-theme-light-placehold;
  border-radius: 24px !important;
}

.attachmentBtnText {
  max-width: 100px;
  font-size: 13px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.paddingclss {
  padding-left: 40px !important ;
}

@media screen and (max-width: 959px) {
  .expireClss {
    text-align: left;
  }
  .topListNew {
    display: none;
  }
}
.pageHeader {
  display: flex;
}
.badgeTextClss {
  margin-right: 80px;
}
</style>

<style scoped>
.v-application .offwhite {
  background-color: #f2f9ff !important;
  border-color: #f2f9ff !important;
}
/deep/ .theme--light.v-icon.mdi-arrow-right-bold-circle {
  color: #0476d9 !important;
}
/deep/ .theme--light.v-icon.mdi-arrow-left-bold-circle {
  color: #0476d9 !important;
}
.v-tab {
  min-width: inherit !important;
  max-width: inherit !important;
  padding: 0;
  margin-right: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
/deep/ .v-slide-group__next--disabled {
  display: none !important;
}
/deep/ .v-slide-group__prev--disabled {
  display: none !important;
}
/deep/ .theme--light.v-tabs-items {
  background-color: transparent !important;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #0476d9 !important;
}

.v-tab--active {
  font-weight: 600 !important;
}
/deep/ .v-tabs-slider-wrapper {
  bottom: 8px !important;
}
/deep/ .theme--light.v-tabs .v-tab--active::before,
.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab:focus::before {
  opacity: 0;
}
/deep/ .theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}
/deep/ .v-ripple__container {
  display: none !important;
}

@media screen and (max-width: 959px) {
  /deep/ .v-tabs-bar {
    padding: 0 12px;
  }
}
</style>
